import React from "react";

import PropTypes from 'prop-types';
import { TransactionCardMobile } from "../../../../../../../../CommonComponents/commonStyles";

const CompletedContributionsMobile = props => {
    const { completedContributions, config, clicked } = props;
    return completedContributions.map((item, dataIndex) => {
      let configOfTab = config(item, dataIndex, () => clicked(item));
      return (
        <TransactionCardMobile key={item.txnId}>
          {configOfTab[0].config.map(ele => ele.render)}
        </TransactionCardMobile>
      );
    });
};

export default CompletedContributionsMobile;

CompletedContributionsMobile.propTypes = {
  clicked: PropTypes.func,
  completedContributions: PropTypes.arrayOf(
    PropTypes.shape({
      allShares: PropTypes.bool,
      amount: PropTypes.number,
      availableBalance: PropTypes.number,
      currentBalance: PropTypes.number,
      description: PropTypes.string,
      dpUser: PropTypes.string,
      dpUserFirstName: PropTypes.string,
      dpUserLastName: PropTypes.string,
      dpUserMiddleName: PropTypes.string,
      dpUserPrefix: PropTypes.string,
      dpUserSuffix: PropTypes.string,
      enteredDate: PropTypes.number,
      giftId: PropTypes.number,
      isRecurring: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      noOfShares: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      orderId: PropTypes.number,
      pendingContribution: PropTypes.bool,
      receivedDate: PropTypes.number,
      reversed: PropTypes.bool,
      settledDate: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      status: PropTypes.string,
      tradeDate: PropTypes.number,
      txnId: PropTypes.number,
      type: PropTypes.string,
      userName: PropTypes.string,
      x: PropTypes.number,
      y3: PropTypes.bool,
      y5: PropTypes.bool,
    })
  ),
};